import React from "react";

import { useIntl } from "react-intl";

import todayOrYesterday from "Libs/datetime";
import Tooltip, {
  calculateAdaptiveItems,
  getStackedYData
} from "src/organization/pages/project/environment/metrics/components/tooltip";
import {
  Flex,
  Table,
  TableRow,
  Td,
  TdMore,
  DateTime
} from "src/organization/pages/project/environment/metrics/components/tooltip/style";
import RoundLegend from "src/organization/pages/project/environment/metrics/http/components/RoundLegend";
import {
  formatNumber,
  formatPercent
} from "src/organization/pages/project/environment/metrics/http/helper";
import { CursorDataSyncType } from "src/organization/pages/project/environment/metrics/http/types";

import { TotalSeriesType } from "../type";

type TooltipContentProps = {
  cursorSync?: CursorDataSyncType;
  series: TotalSeriesType;
  bands: Record<string, string>;
  total?: number;
};

const CPUTooltip = (props: TooltipContentProps) => {
  const intl = useIntl();
  const { chartRect, adaptedCursor } = props.cursorSync || {};
  const { indexedData, absoluteY, xInvert, yInvert, tooltipIsPositionable } =
    adaptedCursor || {};
  const bands = props.bands;

  const { data, date, sum, ...series } = indexedData?.data || {};
  //data and date are not part of the series data so lets omit them
  data && date && sum;
  const seriesEntries = Object.entries<number>(series).sort(
    (a, b) => b[1] - a[1]
  );
  const total = props.total || 0;
  const importantItem = getStackedYData(date, yInvert, props.series);

  const getImportant = (items: [string, number][]) => {
    const existItem = items.find(item => item[0] === importantItem?.key);
    return importantItem && !existItem ? existItem : undefined;
  };

  const { items, excludeCount } = calculateAdaptiveItems(
    seriesEntries,
    absoluteY,
    getImportant
  );
  const more = intl.formatMessage({ id: "more" });
  return (
    <Tooltip
      chartRect={chartRect}
      isVisible={tooltipIsPositionable}
      adaptedCursor={adaptedCursor}
    >
      <Table>
        <TableRow>
          <DateTime colSpan={3}>{todayOrYesterday(xInvert)}</DateTime>
        </TableRow>
        <tbody>
          <TableRow isActive>
            <Td>{formatNumber({ value: total, precision: 2 })} CPU</Td>
            <Td bold colSpan={2}>
              {intl.formatMessage({ id: "max" })}
            </Td>
          </TableRow>
          {items.map(([name, value]) => {
            return (
              <TableRow key={name} isActive={importantItem?.key === name}>
                <Td>
                  <Flex>
                    <RoundLegend color={bands[name]} />
                    <span className="bold">{formatPercent(value, total)}</span>
                  </Flex>
                </Td>
                <Td>{formatNumber({ value, precision: 2 })} CPU</Td>
                <Td>{name}</Td>
              </TableRow>
            );
          })}
          {!!excludeCount && (
            <TableRow>
              <TdMore colSpan={3}>{`+${excludeCount} ${more}`}</TdMore>
            </TableRow>
          )}
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default CPUTooltip;
